import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'services/axiosBaseQuery'
import type {
  GetDuplicateConfigRequest,
  GetDuplicateConfigResponse,
  GetDuplicateConfigTransformedResponse,
} from './types'

export const mrfCommonApi = createApi({
  reducerPath: 'mrfCommonApi',
  tagTypes: ['DuplicateConfig'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/MRF/'}`,
  }),
  endpoints: (builder) => ({
    getDuplicateConfig: builder.query<
      GetDuplicateConfigTransformedResponse,
      GetDuplicateConfigRequest
    >({
      query: ({ clientId, contentType }) => ({
        url: `clients/${clientId}/duplicate_config/${contentType}/`,
        method: 'GET',
      }),
      providesTags: (_, __, req) => [{ id: req.contentType, type: 'DuplicateConfig' }],
      transformResponse: (res: GetDuplicateConfigResponse) => {
        const staticFields: GetDuplicateConfigTransformedResponse['static'] = {}
        const dynamicFields: GetDuplicateConfigTransformedResponse['dynamic'] = {}

        res.forEach((field) => {
          switch (field.type) {
            case 1:
              staticFields[field.id] = true
              break
            case 2:
            default:
              dynamicFields[field.id] = true
              break
          }
        })
        return { static: staticFields, dynamic: dynamicFields }
      },
    }),
  }),
})

export const { useGetDuplicateConfigQuery } = mrfCommonApi
